module.exports = __webpack_public_path__ + "assets/img/haveObtained_see.9de5d198.png";